import {
  loadMore,
  setNextPage,
  setPageNumber,
  setPageSize,
  setPrevPage,
  setSort,
} from 'Core/actions/request';
import { setResponse } from 'Core/actions/response';
import type { EpicArg } from 'Core/epics/common';
import { tryResponseRedirect } from 'Core/epics/redirect';
import { searchPreselectionSelector } from 'Core/selectors/preselection';
import { logRuntimeError } from 'Diagnostics/diagnostics';
import requestConfig from 'Models/uiConfig/requestConfig';
import { generateSearchId } from 'Modules/serverApi/common/searchId';
import { abortControllerCreator, search } from 'Modules/serverApi/index';
import { flushProductImpressions } from 'Modules/serverApi/track';
import type { SearchRequest } from 'Modules/serverApi/types';
import { setSearchId } from 'Utils/userStorage';

const requestController = abortControllerCreator();

const productsOnlyActions: string[] = [
  loadMore.type,
  setNextPage.type,
  setPageNumber.type,
  setPageSize.type,
  setPrevPage.type,
  setSort.type,
];

export default function sendRequest(arg: EpicArg, request: SearchRequest): void {
  const { state, dispatch, action } = arg;
  const onInit = action.meta?.onInit;
  const { extra = {}, responseMeta = {} } = action.meta ?? {};

  const preselection = searchPreselectionSelector(state);
  const selection = [...(request.selection ?? []), ...preselection];

  if (onInit) {
    selection.push(
      ...requestConfig
        .getInitPreselection()
        .filter(({ field }) => !selection.some((value) => value.field === field)),
    );
  }

  const req: SearchRequest = {
    ...request,
    selection,
    extra,
    preferProductsOnly: productsOnlyActions.includes(action.type),
  };

  if (requestConfig.isAnalyticsEnabled()) {
    flushProductImpressions();
    const searchId = generateSearchId(req);
    setSearchId(searchId);
  }

  search(req, requestController.create(), onInit)
    .then((response) => {
      if (response.State === 'cancelled') {
        return;
      }

      if (tryResponseRedirect(arg, response)) {
        // Don't visually change the search results on the page if there is a redirect,
        // but dispatch Fitment Search action to ensure a vehicle is selected before redirect
        return;
      }

      dispatch(
        setResponse(response, {
          appendItems: request.action === 'add',
          preselection,
          onInit,
          ...responseMeta,
        }),
      );
    })
    .catch((err) => {
      logRuntimeError({ source: 'search_request', error: err });
    });
}
